import { useEffect, useState } from 'react';
import { envoisApi } from '../api/resources';
import { localeDates, tr, trf } from '../lib/i18n';
import { C } from '../theme/palette';

/** Comment le journal nomme chaque canal, sur la fiche de la pièce. */
const PAR = {
  EMAIL: '✉️ e-mail',
  LES_DEUX: '✉️ e-mail',
  SMS: '💬 SMS',
  WHATSAPP: '🟢 WhatsApp',
  PARTAGE: '📲 partage',
};

/**
 * Dernier envoi d'une offre ou d'une facture, tel que le journal le garde :
 * par e-mail depuis SwissTech, ou par WhatsApp, SMS… noté après un partage.
 *
 * @param {object} props propriétés
 * @param {'DEVIS'|'FACTURE'} props.type sorte de pièce
 * @param {number|string} props.id pièce ; tant qu'elle n'est pas enregistrée, rien ne s'affiche
 * @param {number} [props.version] change après un envoi, pour relire le journal
 * @param {import('react').ReactNode} [props.sinon] ce qui s'affiche quand le journal n'a rien
 *   (une pièce envoyée avant que le journal ne note les partages)
 * @returns {import('react').ReactElement|null} la ligne, ou rien sans envoi
 */
export function DernierEnvoi({ type, id, version, sinon = null }) {
  const [dernier, setDernier] = useState(null);
  useEffect(() => {
    if (!Number.isInteger(id)) return undefined;
    let annule = false;
    envoisApi
      .journal({ size: 200 })
      .then((page) => {
        const lignes = (page?.content || page || []).filter(
          (e) => e.type === type && e.reference === id && e.statut !== 'ECHEC',
        );
        if (!annule) setDernier(lignes[0] || null);
      })
      .catch(() => {});
    return () => {
      annule = true;
    };
  }, [type, id, version]);
  if (!dernier) return sinon;
  const quand = new Date(dernier.envoyeLe);
  const date = quand.toLocaleDateString(localeDates(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const heure = quand.toLocaleTimeString(localeDates(), { hour: '2-digit', minute: '2-digit' });
  return (
    <div
      role="status"
      style={{ fontSize: 10.5, fontWeight: 700, color: C.green, margin: '0 0 8px' }}
    >
      {trf('📨 Envoyée par {0} le {1} à {2}', tr(PAR[dernier.canal] || PAR.EMAIL), date, heure)}
    </div>
  );
}
